import { PageHero } from "@/components/PageHero";
import { SOCIETY } from "@/lib/data";

const About = () => (
  <div data-testid="about-page">
    <PageHero
      overline="About"
      title={
        <>
          A community designed for
          <span className="italic text-brand-gold"> the future.</span>
        </>
      }
      lead="Kolte-Patil iTowers Exente is a premium, 4-acre residential community in Bengaluru's most happening neighbourhood — Electronic City."
      image="https://images.unsplash.com/photo-1714386450133-fc18de6fe2d2?auto=format&fit=crop&w=2000&q=80"
    />

    <section className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-12">
        <div className="md:col-span-3 space-y-6 text-brand-mute leading-relaxed text-lg">
          <p>
            Spread across <strong className="text-brand-forest">4 lush acres</strong>, iTowers Exente is home to{" "}
            <strong className="text-brand-forest">438 thoughtfully designed 2 & 3 BHK apartments</strong> across five
            iconic towers, each rising 24 storeys high with three-side open city views.
          </p>
          <p>
            Located in Konappana Agrahara, the community is a ten-minute walk from Infosys, TCS, GE, Tech Mahindra,
            Schneider Electric, HP and almost every major tech campus that calls Electronic City home.
          </p>
          <p>
            Beyond the architecture, Exente is defined by its people — a warm, multicultural community of families,
            young professionals, and retirees who collectively shape the calendar of celebrations, sport, learning
            and giving back.
          </p>
        </div>
        <aside className="md:col-span-2 bg-brand-sage/40 rounded-2xl p-8 h-fit md:sticky md:top-32">
          <div className="text-xs uppercase tracking-[0.25em] text-brand-leaf font-semibold mb-4">
            At a glance
          </div>
          <dl className="space-y-4">
            {[
              ["Project", "Kolte-Patil iTowers Exente"],
              ["Configuration", "2 & 3 BHK Apartments"],
              ["Towers", "5 · 24 floors each"],
              ["Total Homes", "438"],
              ["Land Area", "4 acres"],
              ["Open Space", "≈ 70%"],
              ["Location", "Konappana Agrahara, Electronic City"],
            ].map(([k, v]) => (
              <div
                key={k}
                className="flex justify-between gap-4 py-3 border-b border-brand-sage last:border-0"
              >
                <dt className="text-sm text-brand-mute">{k}</dt>
                <dd className="text-sm font-medium text-brand-forest text-right">{v}</dd>
              </div>
            ))}
          </dl>
        </aside>
      </div>
    </section>
  </div>
);

export default About;
